import * as React from 'react';
import { Tour, TourProps } from 'antd';
import ConfettiVideo from '../../../../../frontend/assets/01_reeach-maker_tour_confetti.mp4';
import NavigationVideo from '../../../../../frontend/assets/02_reeach-maker_tour_navigation.mp4';
import EditingVideo from '../../../../../frontend/assets/03_reeach-maker_tour_editing.mp4';
import UneditableAreas from '../../../../../frontend/assets/04_reeach-maker_tour_uneditable-areas_v2.mp4';
import { Trans, useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import SiteBuilderModel from '../../model/SiteBuilderModel';

interface FCProps {}

const PreviewTour: React.FC<FCProps> = observer(({}) => {
  const { t } = useTranslation();

  const steps: TourProps['steps'] = [
    {
      cover: (
        <video src={ConfettiVideo} autoPlay loop muted width={'100%'}></video>
      ),
      title: t('Congratulations! Your website preview is ready!'),
      description: (
        <div>
          {t('You can now edit the website preview.')}
          <br />
          {t(
            'Unleash the full potential of our Website-Editor after you purchased the website!'
          )}
        </div>
      ),
      target: null,
      nextButtonProps: {
        children: <div>{t('Next')}</div>
      },
      prevButtonProps: {
        children: <div>{t('Previous')}</div>
      }
    },
    {
      cover: (
        <video src={NavigationVideo} autoPlay loop muted width={'100%'}></video>
      ),
      title: t('Go through all the pages'),
      description: t(
        `Please go through all the pages of your website and make the necessary adjustments. You can use the “Save and next” and “Previous page” buttons or open the drop down.`
      ),
      target: null,
      nextButtonProps: {
        children: <div>{t('Next')}</div>
      },
      prevButtonProps: {
        children: <div>{t('Previous')}</div>
      }
    },
    {
      cover: (
        <video src={EditingVideo} autoPlay loop muted width={'100%'}></video>
      ),
      title: t('Unhappy with the website?'),
      description: (
        <div>
          <p>
            <Trans i18nKey="editingStepParagraph1" />
          </p>
          <p>
            <Trans i18nKey="editingStepParagraph2" />
          </p>
        </div>
      ),
      target: null,
      nextButtonProps: {
        children: <div>{t('Next')}</div>
      },
      prevButtonProps: {
        children: <div>{t('Previous')}</div>
      }
    },
    {
      cover: (
        <video src={UneditableAreas} autoPlay loop muted width={'100%'}></video>
      ),
      title: t('Some areas are not editable'),
      description: t(
        `Some areas and elements are not editable in the preview due to technical limitations. But after you proceed with the checkout you will receive full access to all areas and elements!`
      ),
      target: null,
      nextButtonProps: {
        children: <div>{t('Close')}</div>
      },
      prevButtonProps: {
        children: <div>{t('Previous')}</div>
      }
    }
  ];

  return (
    <Tour
      open={SiteBuilderModel.isPreviewTourOpen}
      onClose={() => {
        SiteBuilderModel.setPreviewTourOpen(false);
      }}
      steps={steps}
    />
  );
});

export default PreviewTour;
